function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6931 0.7854C28.6741 0.7854 27.0425 2.43344 27.0425 4.43607V23.5523C27.0425 24.9375 27.8243 26.1573 28.9792 26.7744C31.4141 28.0756 34.3438 26.2875 34.3438 23.5523V4.43607C34.3438 2.42309 32.7061 0.7854 30.6931 0.7854Z",
  fill: "#FF6F07"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9131 6.59263V18.2422C10.9131 18.7918 10.4671 19.2379 9.91748 19.2379C9.36789 19.2379 8.92184 18.7918 8.92184 18.2422V6.62648H5.33755C2.58827 6.62648 0.359375 8.85538 0.359375 11.6047V16.3837C0.359375 19.133 2.58827 21.3619 5.33755 21.3619H9.11168L10.8713 29.6124C11.3399 31.8599 13.2947 33.5113 15.6132 33.573C17.4286 33.6215 18.7196 32.0298 18.3678 30.3478L17.6483 26.8923C19.605 26.2531 21.141 24.6807 21.733 22.708C22.8634 22.9144 23.9752 23.1673 25.0511 23.4926V4.5144C20.831 5.85592 15.3248 6.47753 10.9131 6.59263ZM17.2387 24.9256C17.033 23.9399 16.8298 22.9629 16.6281 21.9951C17.6622 22.1153 18.705 22.2394 19.7411 22.3874C19.3123 23.5496 18.3957 24.4802 17.2387 24.9256Z",
  fill: "#FF6F07"
});

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.0a13ac65.svg";
export { ForwardRef as ReactComponent };